var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"routes-history"},[_c('Icon',{staticClass:"icon",attrs:{"backdrop":true,"type":"back"},on:{"click":_vm.back}}),_c('Icon',{attrs:{"backdrop":true,"type":"forward"},on:{"click":_vm.forward}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }